// molecules/CarouselItem.tsx
"use client"

import { useCarousel } from "@/contexts/CarouselContext"
import * as React from "react"
import { cn } from '@/utils/index'

export const CarouselItem = React.forwardRef<HTMLDivElement, React.HTMLAttributes<HTMLDivElement>>(
  ({ className, ...props }, ref) => {
    const { orientation } = useCarousel()

    return (
      <div
        ref={ref}
        role="group"
        aria-roledescription="slide"
        className={cn("min-w-0 shrink-0 grow-0 basis-full", orientation === "horizontal" ? "pl-4" : "pt-4", className)}
        {...props}
      />
    )
  }
)

CarouselItem.displayName = "CarouselItem"
